import { useCallback, useEffect, useState } from 'react';

type Props<K extends string> = {
  initialSort: { key: K; dir: SortDir };
  resetDeps?: unknown[];
};
export function useTableSortAndPage<K extends string>({ initialSort, resetDeps = [] }: Props<K>) {
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(initialSort);

  useEffect(() => {
    setPage(1);
    // resetDeps is a spread array controlled by the caller — React's exhaustive-deps rule
    // doesn't understand this pattern, but the intent is correct: callers pass the values
    // they want to trigger a page reset on, and this effect fires whenever those change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetDeps);

  const toggleSort = useCallback((key: K) => {
    setPage(1);
    setSort((prev) => {
      if (prev.key !== key) return { key, dir: 'asc' as const };
      return { key, dir: prev.dir === 'asc' ? ('desc' as const) : ('asc' as const) };
    });
  }, []);

  return { page, setPage, sort, setSort, toggleSort };
}
